import React from 'react';

import {
  BACKEND_CHANGELOG_META,
  BACKEND_CHANGELOG_RELEASES,
} from './backend-changelog-data';
import ChangelogView from './changelog-view';

const BackendChangelog = () => (
  <ChangelogView
    title="Changelog Back-end"
    description="Histórico das entregas recentes da API usada pelo CCO, incluindo endpoints, segurança, integrações e correções operacionais."
    currentVersion={BACKEND_CHANGELOG_META.version}
    releases={BACKEND_CHANGELOG_RELEASES}
  />
);

export default BackendChangelog;
